import { render, staticRenderFns } from "./InviteDialog.vue?vue&type=template&id=d784b28e"
import script from "./InviteDialog.vue?vue&type=script&lang=js"
export * from "./InviteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports